import Lightbox from "./Lightbox";

export default class VideoPlayer extends Lightbox {

    constructor(element) {

        super(element);
        this.currentPlayer = null;
        this.$uiContainer = null; // enthält poster und play button
        this.$videoContainer = null;
        this.$playButton = null;

        this.$videoJs = null;
        this.videoUrl = null;

        this.aspectRatio = null;

        this.playListener = null;
        this.playerPlayListener = null;
        this.playerPauseListener = null;
        this.playerEndedListener = null;

        this.lightbox = false;
        this.$lightboxOpenHandler = null;

        this.autoplay = false;
        this.initialized = false;

        this.visibility = 1;
        this.minVisibility = 0.75;

        this.disablePlayButton = false;

        this.muted = true;
        this.$muteButton = null;
        this.muteListener = null;

        this.$fullScreenButton = null;
        this.fullScreenListener = null;

        this.hideControls = false;
        this.$pauseButton = null;

        this.$progressBar = null;
        this.timeUpdateListener = null;

        this.usePagination = false;

        this.init();
    }

    showUiContainer() {
        this.$uiContainer.animate({'opacity': '1'}); // höhe des posters bleibt so erhalten
    }

    hideUiContainer() {
        this.$uiContainer.animate({'opacity': '0'}); // höhe des posters bleibt so erhalten
    }

    createListener() {

        let mySelf = this;

        this.playListener = function (event) {
            if (!mySelf.disablePlayButton) {
                if (this.$videoJs != null) {
                    if (mySelf.currentPlayer != null) {
                        mySelf.hideUiContainer();
                        mySelf.playVideo();
                    } else {
                        mySelf.initVideoPlayer();
                    }
                } else {
                    mySelf.loadVideoTemplate();
                }
                event.stopPropagation();
            }
        }

        this.muteListener = function (event) {
            if (mySelf.currentPlayer != null) {
                if (mySelf.currentPlayer.muted()) {
                    mySelf.unmuteVideo();
                } else {
                    mySelf.muteVideo();
                }
            }
        }

        this.pauseListener = function (event) {
            if (mySelf.currentPlayer != null) {
                if (mySelf.currentPlayer.paused()) {
                    mySelf.playVideo();
                } else {
                    mySelf.pauseVideo();
                }
            }
        }

        this.fullScreenListener = function (event) {
            if (mySelf.currentPlayer != null) {
                mySelf.requestFullScreen();
            }
        }

        this.timeUpdateListener = function (event) {
            if (mySelf.currentPlayer != null) {
                mySelf.setProgress();
            }
        }

    }

    init() {
        super.init();

        this.createListener();

        const mySelf = this;

        this.videoUrl = this.$element.attr('data-video-url');
        this.aspectRatio = parseFloat(this.$element.data('content-aspect-ratio'));

        let $uiContainer = this.$element.find('[data-type="ui-container"]');
        if ($uiContainer.length > 0) {
            this.$uiContainer = $uiContainer;
        }

        this.$videoContainer = this.$element.find('[data-type="video-container"]');

        this.$playButton = this.$uiContainer.find('[data-action="play"]');

        // VideoJS HTML-Struktur könnte optional nachgeladen werden, oder bereits vorhanden sein
        let $videoJs = this.$element.find('video-js');
        if ($videoJs.length == 1) {
            this.$videoJs = $videoJs;
        }

        const muted = this.$element.data('muted');
        if (muted != undefined) {
            this.muted = muted;
        }

        // deaktiviert die inline Play Funktion aber zeigt den Button weiterhin an
        const disablePlayButton = this.$element.attr('data-disable-playbutton');
        if (disablePlayButton != undefined && disablePlayButton == true) {
            this.disablePlayButton = true;
        }

        let lightbox = this.$element.attr('data-lightbox');
        if (lightbox != undefined && lightbox == true) {
            this.lightbox = true;

            let $lightboxOpenHandler = this.$element.find('[data-type="lightbox-open"]');
            if ($lightboxOpenHandler.length > 0) {
                this.$lightboxOpenHandler = $lightboxOpenHandler;
            }

            this.$element.on('click', this.openLightboxListener);
            if (this.$lightboxOpenHandler != null) {
                this.$lightboxOpenHandler.on('click', this.openLightboxListener);
            }
        }

        let muteButton = this.$element.find('[data-type="mute-button"]');
        if (muteButton != undefined) {
            this.$muteButton = muteButton;
            this.$muteButton.on('click', this.muteListener);
        }

        let pauseButton = this.$element.find('[data-type="pause-button"]');
        if (pauseButton != undefined) {
            this.$pauseButton = pauseButton;
            this.$pauseButton.on('click', this.pauseListener);
        }

        let fullScreenButton = this.$element.find('[data-type="fullscreen-button"]');
        if (fullScreenButton != undefined) {
            this.$fullScreenButton = fullScreenButton;
            this.$fullScreenButton.on('click', this.fullScreenListener);
        }

        const progressId = this.$element.data('progress-id');
        if (progressId != undefined) {
            const progressBar = document.getElementById('progress-' + progressId);
            if (progressBar != undefined) {
                this.$progressBar = progressBar;
            }
        }

        const hideControls = this.$element.attr('data-hide-controls');
        if (hideControls != undefined) {
            this.hideControls = hideControls;
        }
        const autoplay = this.$element.data('autoplay');

        this.usePagination = $('[data-type="video-pagination"]').length > 0;

        if (autoplay) {
            this.autoplay = true;
            if (this.$videoJs != null) {
                this.initVideoPlayer();
            } else {
                this.loadVideoTemplate();
            }
        }
        this.$playButton.on('click', this.playListener);
    }

    initVideoPlayer() {
        const mySelf = this;

        if (this.$videoJs != null) {
            // derzeit skaliert der player relativ zum poster (autosizeimage)
            let params = {
                "muted": true,
                "playsinline": "playsinline",
                "controls": true,
                "fluid": true,
                "pictureInPictureToggle": false,
                "controlBar": {
                    "liveDisplay": true
                }
            };

            if (!this.muted) {
                params.muted = false;
            }
            if (this.hideControls) {
                params.controls = false;
            }
            this.currentPlayer = videojs(this.$videoJs.attr('id'), params);
            if (this.currentPlayer.autoplay) {
                this.autoplay = true;
            }

            this.$videoJs.find('.vjs-big-play-button').addClass('hidden');// button vom player ausblenden

            $(document).on('allvideo:stop', function () {
                // mySelf.stopVideo();
                mySelf.dispose();
            });

            this.$videoJs.on('video:stop', function () {
                // mySelf.stopVideo();
                mySelf.dispose();
            });

            this.hideUiContainer();

            this.playerPlayListener = function (event) {
                mySelf.stopAllOtherVideos();
                event.stopPropagation();
            };

            this.playerPauseListener = function (event) {
                event.stopPropagation();
            };

            this.playerEndedListener = function (event) {
                // UI-Buttons ausblenden
                if (mySelf.$fullScreenButton != null) {
                    mySelf.$fullScreenButton.addClass('hidden');
                }
                if (mySelf.$muteButton != null) {
                    mySelf.$muteButton.addClass('hidden');
                }
                if (mySelf.$pauseButton != null) {
                    mySelf.$pauseButton.addClass('hidden');
                    mySelf.$pauseButton.addClass('paused');
                }
                if (mySelf.usePagination) {
                    $('[data-type="video-pagination"]').removeClass('opacity-0');
                }

                mySelf.dispose();
            };

            this.currentPlayer.on('play', this.playerPlayListener);
            this.currentPlayer.on('pause', this.playerPauseListener);
            this.currentPlayer.on('ended', this.playerEndedListener);

            if (this.$progressBar != null) {
                this.currentPlayer.on('timeupdate', this.timeUpdateListener);
            }

            if (this.autoplay) {
                this.playVideo();
            }
        }
    }

    pauseVideo() {
        if (this.currentPlayer != null) {
            this.currentPlayer.pause();

            if (this.$pauseButton != null) {
                this.$pauseButton.addClass('paused');
            }
            if (this.usePagination) {
                $('[data-type="video-pagination"]').removeClass('opacity-0');
            }
        }
    }

    stopVideo() {
        if (this.currentPlayer != null) {
            this.currentPlayer.pause();
            $(document).trigger("IntersectionObserver:unobserve", this.element);
            this.dispose();
        }
    }


    playVideo() {
        if (this.currentPlayer != null) {
            this.currentPlayer.play();
            $(document).trigger("IntersectionObserver:observe", this.element);

            // UI-Buttons einblenden
            if (this.$fullScreenButton != null) {
                this.$fullScreenButton.removeClass('hidden');
            }
            if (this.$muteButton != null) {
                this.$muteButton.removeClass('hidden');
            }
            if (this.$pauseButton != null) {
                this.$pauseButton.removeClass('hidden');
                this.$pauseButton.removeClass('paused');
            }
            if (this.usePagination) {
                $('[data-type="video-pagination"]').addClass('opacity-0');
            }
        }
    }

    muteVideo() {
        if (this.currentPlayer != null) {
            this.currentPlayer.muted(true);
            this.$muteButton.addClass('muted');
        }
    }

    unmuteVideo() {
        if (this.currentPlayer != null) {
            this.currentPlayer.muted(false);
            this.$muteButton.removeClass('muted');
        }
    }

    requestFullScreen() {
        if (this.currentPlayer != null) {
            this.currentPlayer.requestFullscreen();
        }
    }

    setProgress() {
        if (this.currentPlayer != null) {
            let currentTime = this.currentPlayer.currentTime();
            let duration = this.currentPlayer.duration();
            let progress = currentTime / duration;
            if (this.$progressBar != null) {
                this.$progressBar.style.width = progress * 100 + '%';
            }
        }
    }

    /**
     * Alle bereits initialisierten Player stoppen.
     */
    stopAllOtherVideos() {
        const availablePlayers = videojs.getPlayers();

        for (const [id, videoPlayer] of Object.entries(availablePlayers)) {
            if (this.$videoJs != undefined) {

                if (id != this.$videoJs.attr('id')) {
                    if (videoPlayer != null) {
                        $('#' + id).trigger("video:stop");
                    }
                }
            }
        }
    }

    /**
     * Initialisierte Player, welche außerhalb des Sichtbereichs liegen, stoppen.
     *
     */
    stopInvisibleVideo() {
        if (this.currentPlayer != null) {
            if (!this.currentPlayer.isFullscreen()) {
                if (this.visibility < this.minVisibility) {
                    this.pauseVideo();
                }
            }
        }
    }

    handleVisibilityChange(visibility) {
        this.visibility = visibility;
        this.$element.attr('data-visibility', this.visibility);
        this.stopInvisibleVideo();
    }

    /**
     * Player stoppen und löschen
     */
    dispose() {

        if (this.currentPlayer != null) {
            this.currentPlayer.off('play', this.playerPlayListener);
            this.currentPlayer.off('pause', this.playerPauseListener);
            this.currentPlayer.off('ended', this.playerEndedListener);

            this.currentPlayer.dispose();
            this.currentPlayer = null;
        }

        if (this.$uiContainer != null) {
            this.showUiContainer();
            this.$videoContainer.empty();
        }

    }


    destroyListener() {

        super.destroyListener();

        $(document).trigger("IntersectionObserver:unobserve", this.element);

        this.$playButton.off('click', this.playListener);

        if (this.$lightboxOpenHandler != null) {
            this.$lightboxOpenHandler.off('click', this.openLightboxListener);
        }
        if (this.$muteButton != null) {
            this.$muteButton.off('click', this.muteListener);
        }
        if (this.$fullScreenButton != null) {
            this.$fullScreenButton.off('click', this.fullScreenListener);
        }

        if (this.currentPlayer != null) {
            this.currentPlayer.off('play', this.playerPlayListener);
            this.currentPlayer.off('pause', this.playerPauseListener);
            this.currentPlayer.off('ended', this.playerEndedListener);

            if (this.$progressBar != null) {
                this.currentPlayer.off('timeupdate', this.timeUpdateListener);
            }

            this.currentPlayer.dispose();
            this.currentPlayer = null;
        }

    }


    loadVideoTemplate() {
        const mySelf = this;

        let jqxhr = $.post(this.videoUrl, {}, function () {
        }, 'html')
            .done(function (response) {
                if (mySelf.$videoContainer != undefined) {
                    mySelf.$videoContainer.empty().html(response);
                    let $videoJs = mySelf.$element.find('video-js').first();
                    if ($videoJs.length == 1) {
                        mySelf.$videoJs = $videoJs;
                    }
                    mySelf.initVideoPlayer();
                }
            });
    }

    loadLightboxContent() {
        const $autoSizeImage = this.$element.find('[data-type="autosizeimage"]');
        const imageData = {
            width: $autoSizeImage.attr('data-width'),
            height: $autoSizeImage.attr('data-height'),
            aspectratio: $autoSizeImage.attr('data-aspectratio'),
            imgUrl: $autoSizeImage.attr('data-img-url')
        };

        return this.templatesWorker.loadVideoplayerTemplate(this.videoUrl, imageData, 1, false, false, false, false, true, false, false, this.muted);
    }

}